/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Task } from 'ember-concurrency';
import { DATA_INDEX_TYPE_ACTIVITY_LOGS } from 'cio/utils/data-index';

import AttributeModel from 'cio/models/attribute';
import EventModel from 'cio/models/event';
import LogModel from 'cio/models/log';

interface RecentActivityArgs {
  item: AttributeModel | EventModel;
  fetchLogsTask: Task<LogModel[], []>;
  onSendTestEventWithLog?: (log: LogModel) => unknown;
}

export default class RecentActivity extends Component<RecentActivityArgs> {
  get activityLogType() {
    return DATA_INDEX_TYPE_ACTIVITY_LOGS[this.args.item.type];
  }
}
